'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));

// http://css-tricks.com/snippets/jquery/serialize-form-to-json/
$.fn.extend({
  serializeJSON: function serializeJSON() {
    var obj = {};
    var arr = this.serializeArray();
    arr.forEach(function (el) {
      if (obj[el.name]) {
        if (!obj[el.name].push) {
          obj[el.name] = [obj[el.name]];
        }
        obj[el.name].push(el.value || '');
      } else {
        obj[el.name] = el.value || '';
      }
    });

    return obj;
  }
});

module.exports = $;
